<div class="container mt-4">
    <div>
        <button type="button" class="btn btn" (click)="goBack()" style="color: blue;" >
            <img src="assets/img/icons/back.png" alt="Back" style="width: 16px; height: 16px; margin-right: 5px; color: blue;"> Back
        </button>
    </div>
    <h2>Study-crc-monitoring table</h2>
    <table class="table table-bordered mt-3">
      <thead>
        <tr>
          <th>Site_activity_name</th>
          <th>Date</th>
          <th>Report Link</th>
          <th>Comment</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of displayedData">
          <tr>
            <td>{{ row.Site_activity_name }}</td>
            <td>{{ row.date }}</td>
            <td><a *ngIf="row.reportLink" [href]="row.reportLink" target="_blank">{{ row.reportLink }}</a></td>
            <td>{{ row.comment }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <button class="btn btn-success" (click)="exportToExcel()">Download</button>
  </div>
  